<template>
  <div>
    <PageTitle :title="$t('global.api-tokens')">
      <template #actions>
        <Btn @click="generateToken" variant="primary">{{ $t("global.generate-api-token") }}</Btn>
      </template>
    </PageTitle>
    <ApiTokensTable :tokens="apiTokens" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import ApiTokensTable from "@/components/smart/tables/ApiTokensTable";
import Btn from "@/components/display/Btn";
import GenerateApiToken from "@/components/smart/modals/GenerateApiToken";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "APITokensPage",
  components: { ApiTokensTable, Btn, PageTitle },
  setup() {
    onMounted(() => {
      store.dispatch("tokens/getList");
    });

    const apiTokens = computed(() => store.getters["tokens/getTokens"]);

    const generateToken = () => {
      store.dispatch("modals/open", {
        template: GenerateApiToken,
      });
    };

    return { apiTokens, generateToken };
  },
};
</script>
